// Partner referral codes (BOT-1774). A ?referrer= link on any dashboard page sets
// the shared .bottle.com cookie (www.bottle.com sets the same one), and the
// get-started journeys send it with the token mint, the basics step and the
// signup; the older /sign-up flow sends it with its token mint and signup.
// A code the merchant typed is sent as 'code' and beats a link's.
//
// Last touch in the browser: a newer partner link replaces the stored code.
import Cookies from 'js-cookie'

import {
  cookieDomainFor,
  normalizeReferralCode,
  REFERRER_COOKIE,
  REFERRER_MAX_AGE_DAYS,
  REFERRER_PARAM
} from '../../referrer-cookie'

function currentHostname() {
  return typeof window === 'undefined' ? '' : window.location.hostname
}

export function captureReferralCode(query, hostname = currentHostname()) {
  const code = normalizeReferralCode(query && query[REFERRER_PARAM])
  if (!code) return
  const domain = cookieDomainFor(hostname)
  Cookies.set(REFERRER_COOKIE, code, {
    expires: REFERRER_MAX_AGE_DAYS,
    path: '/',
    sameSite: 'Lax',
    ...(domain && { domain })
  })
}

export function storedReferralCode() {
  return normalizeReferralCode(Cookies.get(REFERRER_COOKIE)) || ''
}

export function referralCodeParams(typedCode = '') {
  const typed = normalizeReferralCode(typedCode)
  if (typed) return { referral_code: typed, referral_source: 'code' }
  const linked = storedReferralCode()
  return linked ? { referral_code: linked, referral_source: 'link' } : {}
}
